import { render, staticRenderFns } from "./pdIndex.vue?vue&type=template&id=1c067f60&"
import script from "./pdIndex.vue?vue&type=script&lang=js&"
export * from "./pdIndex.vue?vue&type=script&lang=js&"
import style0 from "./pdIndex.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports